import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

import { Positions } from "@/src/components/Positions";

type State = {
  sectionOrder?: Positions;
  disabledSections?: string[];
  taskOrder?: { [sectionId: string]: { [taskId: string]: number } };
  disabledTasks?: { [sectionId: string]: string[] };
  assignedRoleIds?: string[];
};
const CTX = createContext<{
  state: State;
  setState: Dispatch<SetStateAction<State>>;
}>({
  state: {},
  setState: () => {},
});

export const RoutineStoreCustomizeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, setState] = useState<State>({});
  return <CTX.Provider value={{ state, setState }}>{children}</CTX.Provider>;
};

export const useRoutineStoreCustomizeState = () => {
  return useContext(CTX);
};
